<template>
  <v-text-field
    v-bind="commonProps"
    filled
    v-model="farm_number"
    label="EFP #"
    :rules="rules"
    type="number"
    :error-messages="farmNumErrorMessages"
    :disabled="loading"
    @input="onInput" />
</template>

<script>
import Input from 'vuetify-admin/src/mixins/input'

export default {
  mixins: [Input],
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    if (this.input) {
      this.farm_number = this.input
    } else {
      this.getRandomFarmNumber()
    }
  },
  data() {
    return {
      farm_number: null,
      farmNumErrorMessages: [],
      availableFarmNumbers: new Set([]),
      loading: false,
    }
  },
  methods: {
    async getRandomFarmNumber() {
      try {
        this.loading = true
        const response = await this.$admin.http.get(
          '/api/available_farm_numbers'
        )

        if (!response.data.farm_numbers.length) {
          this.$admin.toast.error('There are no available farm numbers.')
          return
        }

        this.availableFarmNumbers = new Set(response.data.farm_numbers)
        this.farm_number = Number(this.getRandom())
        this.update(this.farm_number)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    getRandom() {
      const array = Array.from(this.availableFarmNumbers)
      const index = Math.floor(Math.random() * array.length)

      return array[index]
    },

    onInput(value) {
      const num = Number(value)
      this.farmNumErrorMessages = []
      if (!num || num < 1000 || num > 9999) return

      if (!this.availableFarmNumbers.has(num)) {
        this.farmNumErrorMessages = ['This farm number is already in use.']
      }
    },
  },
}
</script>
